module.exports = __webpack_public_path__ + "static/fonts/Arita-dotumM.e0ff108.eot";